import Icon from '../components/Icon.vue'

Icon.register({
  'venus-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 176c0 68.5-47.9 125.9-112 140.4v51.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-64.1-14.5-112-71.9-112-140.4 0-79.5 64.5-144 144-144s144 64.5 144 144zM64 176c0 44.1 35.9 80 80 80s80-35.9 80-80-35.9-80-80-80-80 35.9-80 80zM400 316.4v51.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1 24.6-19.3 55.5-30.9 89.2-30.9 79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/venus-double.js
// module id = 2085
// module chunks = 0